// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22.0077 17.4257 17.4257 22.0077 12 22ZM17.5833 17.4167C18.9935 15.9665 19.781 14.0227 19.7778 12C19.7778 7.70222 16.2967 4.22222 12 4.22222C7.70222 4.22222 4.22222 7.70222 4.22222 12C4.22222 16.2967 7.70222 19.7778 12 19.7778C14.0227 19.781 15.9665 18.9935 17.4167 17.5833L17.5833 17.4167ZM7.55555 10.8889H16.4444V13.1111H7.55555V10.8889Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
